import Iframe from './Iframe'

export default Iframe
